import { Event } from './event';
import { InputBatch } from '@/models/input-batch';

export class InputBatchApprovalStartedEvent extends Event<InputBatch> {}
